"use client";
import React from "react";
import {
  Box,
  Center,
  Separator,
  Table,
  VStack,
  Text,
  HStack,
  SimpleGrid,
  Flex,
} from "@chakra-ui/react";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import PricingFooter from "@/components/pricingFooter";
import { TRAFFIC_CONSTANTS } from "./constants";

export const DesktopView = () => (
  <Table.Root striped border="2px solid rgb(237,242,247)" width="100%">
    <Table.Header>
      <Table.Row>
        <Table.ColumnHeader textAlign="center">Range</Table.ColumnHeader>
        <Table.ColumnHeader textAlign="center">Discount</Table.ColumnHeader>
        <Table.ColumnHeader textAlign="center">Price / GB</Table.ColumnHeader>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {TRAFFIC_CONSTANTS.data.map((item, index) => (
        <Table.Row key={index}>
          <Table.Cell textAlign="center">{item.range}</Table.Cell>
          <Table.Cell
            textAlign="center"
            color={item.discount === "FREE" ? "green.500" : "primary.200"}
            fontWeight="bold"
          >
            {item.discount}
          </Table.Cell>
          <Table.Cell
            textAlign="center"
            color={item.pricePerGB === "$0.00" ? "green.500" : "primary.200"}
            fontWeight="bold"
          >
            {item.pricePerGB}
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table.Root>
);

export const MobileView = () => (
  <SimpleGrid columns={{ base: 1, sm: 2 }} gap={6}>
    {TRAFFIC_CONSTANTS.data.map((item, index) => (
      <VStack
        key={index}
        borderRadius="lg"
        borderWidth="1px"
        borderColor="gray.200"
        boxShadow="md"
        gap={4}
        w="100%"
        p={4}
        bg="white"
      >
        <Flex direction="column" w="full">
          <Text fontWeight="bold" fontSize="lg">
            {item.range}
          </Text>
        </Flex>

        <Separator borderColor="gray.200" />

        <HStack w="full" justify="space-between">
          <Text fontSize="sm" color="text.100">
            Discount
          </Text>
          <Text
            fontWeight="bold"
            color={item.discount === "FREE" ? "green.500" : "primary.200"}
          >
            {item.discount}
          </Text>
        </HStack>

        <HStack w="full" justify="space-between">
          <Text fontSize="sm" color="text.100">
            Price / GB
          </Text>
          <Text
            fontWeight="bold"
            color={item.pricePerGB === "$0.00" ? "green.500" : "primary.200"}
          >
            {item.pricePerGB}
          </Text>
        </HStack>
      </VStack>
    ))}
  </SimpleGrid>
);

const TrafficPricingTable = () => {
  const HeadingVariant = useHeadingVariant();
  return (
    <Box>
      <Heading variant={HeadingVariant} textAlign={"center"} mb={8}>
        {TRAFFIC_CONSTANTS.heading}
      </Heading>
      <Text textAlign={"center"} mb={6} color="gray.600">
        {TRAFFIC_CONSTANTS.desc}
      </Text>
      <Center display={{ md: "none" }} w="full">
        <MobileView />
      </Center>
      <Box display={{ base: "none", md: "block" }}>
        <DesktopView />
      </Box>
      <PricingFooter {...TRAFFIC_CONSTANTS.footer} />
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default TrafficPricingTable;
